import { Badge, Table } from "flowbite-react";
import { formatToReal } from "../../../utils/utils";

const HistoricoConsultas = ({
  historicoConsultas,
  quantidadeTotal,
  periodoInicial,
  periodoFinal,
}) => {
  return (
    <>
      <div className="flex gap-6">
        {quantidadeTotal && (
          <div>
            <span className="font-semibold">Quantidade Total: </span>
            {quantidadeTotal}
          </div>
        )}
        {periodoInicial && periodoFinal && (
          <div>
            <span className="font-semibold">Período: </span>
            {periodoInicial} até {periodoFinal}
          </div>
        )}
      </div>
      <div className="overflow-x-hidden border-gray-100 border rounded-lg mt-1">
        <Table striped>
          <Table.Head>
            <Table.HeadCell
              className="text-center text-black"
              style={{ background: "#3EED98" }}
            >
              Data
            </Table.HeadCell>
            <Table.HeadCell
              className="text-center text-black"
              style={{ background: "#3EED98" }}
            >
              Empresa
            </Table.HeadCell>
          </Table.Head>

          {historicoConsultas?.length > 0 && (
            <Table.Body className="divide-y">
              {historicoConsultas?.slice(0, 5)?.map((consulta, index) => (
                <Table.Row
                  key={index}
                  className="bg-white dark:border-gray-700 dark:bg-gray-800"
                >
                  <Table.Cell className="font-medium text-gray-900 dark:text-white text-center text-black py-1">
                    {consulta?.data || "-"}
                  </Table.Cell>
                  <Table.Cell className="text-center text-black py-1">
                    {consulta?.empresa
                      ? !consulta?.empresa?.toUpperCase()?.includes("ENJOY")
                        ? consulta?.empresa
                        : "Bancos Grandes"
                      : "-"}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          )}
        </Table>
      </div>
      <span className="mt-2 block text-xs italic">
        Exibindo as últimas 5 informações
      </span>
    </>
  );
};

export default HistoricoConsultas;
